import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Card, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from "prop-types";
import {handleTimeAgo, isResponseOk} from "enqc-utilities/src/utils/Utilities";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import PaginationTable from "./PaginationTable";


class UserActivityTable extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            user:this.props.user?this.props.user:{},
            userActivities:[],
            page:1,
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            sortOption:{}
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        let {user} = this.state
        let nextUser = nextProps.user?nextProps.user:{}
        if(user.id!==nextUser.id){
            this.setState({user:nextUser},() => {
                this.getUserActivities()
            })
        }
    }
    getUserActivities(){
        let {user, userActivities, page} = this.state
        this.get(Endpoint.API.USER_ACTIVITIES, {params:{"userNames":user.username, page:page-1}}, null, (res)=>{
            if(isResponseOk(res)){
                userActivities = res.data
                let totalPage = res.totalPage
                let totalElement = res.totalElement
                let pageElement = res.pageElement
                this.setState({userActivities,totalPage, totalElement, pageElement})
            }
        }, false, false)
    }


    render() {
        let {user, userActivities, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <div>
                <Card border="light" className="shadow-sm">
                    <Card.Header>
                        <h5>{label.UserActivity}</h5>
                    </Card.Header>
                    {this.renderDesktopTable()}
                    {this.renderMobileList()}
                    <div className="p-2">
                        <PaginationTable
                            onSelect={(page) => {
                                this.setState({page},() => {
                                    this.getUserActivities()
                                })
                            }}
                            showingRow={userActivities.length}
                            currentPage={page}
                            pageCount={totalPage}
                            totalElement={totalElement}/>
                    </div>

                </Card>
            </div>
        );
    }
    renderDesktopTable(){
        let {user, userActivities, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <Table className="align-items-center table-flush p-0 d-none d-md-table">
                <thead className="thead-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">{label.User}</th>
                    <th scope="col">{label.Type}</th>
                    <th scope="col">{label.Description}</th>
                    <th scope="col">{label.Platform}</th>
                    <th scope="col">{label.TimeActivity}</th>
                </tr>
                </thead>
                <tbody>
                {
                    userActivities.map((userActivity, index)=>{
                        return(
                            <tr key={index}>
                                <td>
                                    {((page - 1) * pageElement) + (++index)}
                                </td>
                                <td scope="row">{userActivity.user.fullname}</td>
                                <td scope="row">{userActivity.message}</td>
                                <td scope="row">{userActivity.typeView}</td>
                                <td scope="row">{userActivity.platform}</td>
                                <td scope="row">{handleTimeAgo(userActivity.created)}</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
        )
    }

    renderMobileList(){
        let {user, userActivities, page, pageElement, totalPage, totalElement, sortOption} = this.state
        return (
            <Table className="table-responsive align-items-center table-flush p-0 d-table d-md-none">
                <thead className="thead-light">
                <tr>
                    <th scope="col" className="p-1 text-center" style={{width:'7%'}}>#</th>
                    <th scope="col">{label.Field}</th>
                    <th scope="col">{label.Information}</th>
                    <th scope="col" className="pe-4 text-end">{label.TimeActivity}</th>
                </tr>
                </thead>
                <tbody>
                {
                    userActivities.map((userActivity, index)=>{
                        return(
                            <React.Fragment>
                                <tr key={index}>
                                    <td className="ps-2 p-1 text-center fw-bold bg-light border-bottom border-success" rowSpan={3} style={{width:'7%'}}>
                                        {((page - 1) * pageElement) + (++index)}
                                    </td>
                                    <td className="ps-2 p-1">
                                        {label.User}
                                    </td>
                                    <td className="p-1">
                                        {userActivity.user.fullname}
                                    </td>
                                    <th rowSpan={3} className="text-end p-1 pe-4 border-bottom border-success">
                                        {handleTimeAgo(userActivity.created)}
                                    </th>
                                </tr>
                                <tr key={index}>
                                    <td className="ps-2 p-1">
                                        {label.Type}
                                    </td>
                                    <td className="ps-2 p-1">
                                        {userActivity.message}
                                    </td>
                                </tr>
                                <tr key={index}>
                                    <td className="ps-2 p-1 border-bottom border-success">
                                        {label.Platform}
                                    </td>
                                    <td className="ps-2 p-1 border-bottom border-success">
                                        {userActivity.platform}
                                    </td>
                                </tr>
                            </React.Fragment>
                        )
                    })
                }
                </tbody>
            </Table>
        )
    }



}

UserActivityTable.propTypes = {
    user : PropTypes.any,
}

export default UserActivityTable